module.exports = __webpack_public_path__ + "assets/img/27_1253.3f51a080.jpg";